import React from 'react';

/**
 * 高亮文本处理函数
 * 将字符串中的 <em> 标签替换为带高亮样式的 React 组件
 * @param {string} text - 包含 <em> 标签的输入字符串
 * @returns {React.ReactNode[]} 处理后的 React 节点数组
 */
export function highlightText(text: string): React.ReactNode[] {
  if (!text) {
    return [];
  }

  const parts = text.split(/(<em>.*?<\/em>)/g);

  return parts.map((part, index) => {
    const match = part.match(/<em>(.*?)<\/em>/);
    if (match) {
      const highlightedText = match[1];
      return (
        <span key={index} className="text-[#2563EB]">
          {highlightedText}
        </span>
      );
    }
    return part;
  });
}

/**
 * 输入：SPARE PART OF RC <em>TOY</em> <em>CAR</em>: CONNECTING BOARDS (SPARE PART) (BULK PACKING)
 * 输出规则：
 * 1. 保留 <em> 标签和内容
 * 2. 第一个<em>标签之前的内容仅保留 2个单词，
 * 3. 最后一个<em>标签之后的内容仅保留 2个单词
 * 举例：
 * 输入：SPARE PART OF RC <em>TOY</em> <em>CAR</em>: CONNECTING BOARDS (SPARE PART) (BULK PACKING)
 * 输出：OF RC <em>TOY</em> <em>CAR</em>: CONNECTING BOARDS
 */

const _truncateText = (text: string): string => {
  if (!text) {
    return '';
  }

  // 查找第一个 <em> 标签的位置
  const firstEmIndex = text.indexOf('<em>');
  if (firstEmIndex === -1) {
    return text;
  }

  // 查找最后一个 </em> 标签的位置
  const lastEmEndIndex = text.lastIndexOf('</em>');
  if (lastEmEndIndex === -1) {
    return text;
  }

  // 处理第一个 <em> 标签之前的内容，保留最后 2 个单词
  const beforeFirstEm = text.substring(0, firstEmIndex);
  const beforeWords = beforeFirstEm.trim().split(/\s+/);
  const truncatedBefore = beforeWords.slice(-2).join(' ');

  // 处理最后一个 </em> 标签之后的内容，保留前 2 个单词
  const afterLastEm = text.substring(lastEmEndIndex + 5); // 5 是 </em> 的长度
  const afterWords = afterLastEm.trim().split(/\s+/);
  const truncatedAfter = afterWords.slice(0, 2).join(' ');

  // 提取所有 <em> 标签及其内容
  const emContent = text.substring(firstEmIndex, lastEmEndIndex + 5);

  // 组合结果
  let result = '';
  if (truncatedBefore) {
    result += truncatedBefore + ' ';
  }
  result += emContent;
  if (truncatedAfter) {
    result += ' ' + truncatedAfter;
  }

  return result;
};
export const truncateText = (text: string): string => {
  try {
    return _truncateText(text);
  } catch (error) {
    console.warn('truncateText error:', error);
    return text;
  }
};
